import React from 'react';
import { ForgeButton } from '@tylertech/forge-react';
const CommonQuestionsSection = ({ commonQuestions, handleCommonQuestionSelection }) => {
    const commonQuestionButtons = commonQuestions.map((commonQuestion, index) => {
        return (React.createElement(ForgeButton, { key: `common-question-${index + 1}`, className: "common-questions-button", type: "outlined", onclick: () => handleCommonQuestionSelection(commonQuestion) },
            React.createElement("button", null,
                React.createElement("span", null, commonQuestion))));
    });
    return React.createElement("div", { className: "common-questions-section" }, commonQuestionButtons);
};
export default CommonQuestionsSection;
//# sourceMappingURL=CommonQuestionsSection.js.map